import { css } from '@emotion/react';

export const mainContainer = css`
    display: grid;
    grid-template-columns: 400px 1fr;
    grid-template-rows: 1fr auto;
    gap: 0 20px;
    width: 100%;
    padding: 20px;
    background-color: #ffffff;
`;

export const mapContainer = css`
    display: flex;
    flex-direction: column;
    height: 790px;
    flex: 1;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
